var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":"Testing Notes"}}),_c('hr'),_c('b-row',[_c('b-col',[_c('h2',[_vm._v("Test Accounts")]),_c('ul',[_c('li',[_vm._v("attorney1@test.com / abcd1234")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }